"use client";

import { WhyChooseUsSection } from "@/components/sections/why-choose-us";
import { whyChooseUs } from "@/lib/data/services-viral-marketing";

export function WhyChooseUs() {
  return (
    <WhyChooseUsSection
      eyebrow={whyChooseUs.eyebrow}
      title={whyChooseUs.title}
      reasons={whyChooseUs.reasons}
      accent={whyChooseUs.accent}
      gridCols={whyChooseUs.gridCols}
    />
  );
}
